module.exports = __webpack_public_path__ + "img/39.2061f146.svg";